// Guest-side export helper. CheerpX devices have no directory listing API, so the guest copies
// files to /files/outbox/ and appends their names to /files/outbox/.list, which the Files tab reads
// back through IDBDevice.readFileAsBlob. The DataDevice refuses nested paths, so the helper lives
// at /data/export.sh (not /data/revault/export.sh). Ported from EndisOS.
export const FILES_MOUNT = "/files";
export const OUTBOX_DIR = FILES_MOUNT + "/outbox";
export const OUTBOX_LIST = "/outbox/.list"; // relative to the files device root
export const EXPORT_HELPER = "/data/export.sh";

export const EXPORT_HELPER_SCRIPT = [
	"#!/bin/sh",
	"# Re:Vault export helper: copies files to /files/outbox and records their names so the",
	"# Files tab of the Linux page can list them for download.",
	"set -e",
	'if [ "$#" -lt 1 ]; then echo "usage: sh $0 <file> [<file>...]" >&2; exit 64; fi',
	"mkdir -p " + OUTBOX_DIR,
	'for f in "$@"; do',
	'  if [ ! -f "$f" ]; then echo "export: not a regular file: $f" >&2; exit 66; fi',
	'  cp -- "$f" ' + OUTBOX_DIR + "/",
	'  basename -- "$f" >> ' + OUTBOX_DIR + "/.list",
	'  echo "exported: $(basename -- "$f")"',
	"done",
	"",
].join("\n");

// Shown in the terminal once the shell is up (CR LF: the console is raw).
export function exportIntro(name) {
	return [
		"Re:Vault Linux (" + name + ")",
		"  Files you send from Re:Vault appear under /data (read-only; copy them: cp /data/<name> ~/).",
		"  To download a file: sh " + EXPORT_HELPER + " ~/report.txt  then open the Files tab.",
		"  Save disk (top bar) before closing, or recent changes may not survive a reload.",
		"",
	].join("\r\n");
}

const SAFE_NAME = /^[^/\\\0]{1,255}$/;
export const isSafeExportName = (n) => SAFE_NAME.test(n) && n !== "." && n !== "..";

// One name per line; last write wins (a re-export moves to the end); unsafe names dropped.
export function parseOutboxList(text) {
	const seen = new Set();
	for (const line of String(text).split(/\r?\n/)) {
		const n = line.trim();
		if (n && isSafeExportName(n)) { seen.delete(n); seen.add(n); }
	}
	return [...seen];
}

// Any file name -> one the DataDevice accepts (no separators, no NUL, not "." / "..").
export function safeImportName(name) {
	const cleaned = String(name || "").normalize("NFC").replace(/[/\\\0]/g, "_").replace(/^\.+$/, "_").trim();
	return (cleaned || "file").slice(0, 255);
}
